module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "panel-box"
  }, [(_vm.with_filter) ? _c('el-input', {
    staticClass: "header-input",
    attrs: {
      "size": "mini",
      "placeholder": _vm.remote ? '输入关键字回车进行过滤' : '输入关键字进行过滤'
    },
    on: {
      "change": _vm.remote_filter_change
    },
    model: {
      value: (_vm.filter_text),
      callback: function($$v) {
        _vm.filter_text = $$v
      },
      expression: "filter_text"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "tree",
    staticClass: "tree",
    class: {
      'with-header': _vm.with_filter
    },
    attrs: {
      "data": _vm.data,
      "size": "mini",
      "default-expanded-keys": _vm.default_expanded_keys,
      "props": {
        label: _vm.tree_props.label,
        children: _vm.tree_props.children,
        disabled: _vm.tree_props.disabled,
      },
      "show-checkbox": _vm.multiple,
      "node-key": _vm.tree_props.key,
      "check-strictly": _vm.check_strictly,
      "expand-on-click-node": true,
      "check-on-click-node": _vm.multiple,
      "highlight-current": true,
      "filter-node-method": _vm.filter_node
    },
    on: {
      "node-click": _vm.handle_node_click,
      "check-change": _vm.handle_check_change,
      "current-change": _vm.handle_current_change,
      "check": _vm.handle_check
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {}, [(data[_vm.tree_props.label_icon]) ? _c('ni-icon', {
          attrs: {
            "iconStyle": {
              width: '1.3em',
              height: '1.3em',
              top: '1px'
            },
            "title": data[_vm.tree_props.icon_title],
            "icon": data[_vm.tree_props.label_icon]
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(node.label))])], 1)
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-36bc3f42","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/base-tree/base-tree.vue
// module id = Qbhp
// module chunks = 81